import React from "react";

function SwapIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      fill="none"
      viewBox="0 0 35 35"
    >
      <path
        fill="#fff"
        d="M21.875 4.5l10.812 10.812H2.917v-2.917h22.73l-5.834-5.833L21.875 4.5zm10.208 15.187v2.917H9.353l5.834 5.833-2.062 2.062L2.313 19.687h29.77z"
      ></path>
    </svg>
  );
}

export default SwapIcon;
